import type { AccountInfo } from '@azure/msal-browser';

export const isE2EWithoutSso = process.env.REACT_APP_LOGIN_TYPE === 'without-sso';

export const e2eCustomerAuthToken =
  process.env.REACT_APP_E2E_AUTH_TOKEN || 'snapinsight-e2e-customer-token';

export const e2eCustomerUserId =
  process.env.REACT_APP_E2E_USER_ID || '22222222-2222-4222-8222-222222222222';

export type E2ECustomerAccount = AccountInfo & { idToken: string };

export const createE2ECustomerAccount = (): E2ECustomerAccount => ({
  homeAccountId: 'snapinsight-e2e-customer',
  environment: 'E2E',
  tenantId: 'snapinsight-e2e-tenant',
  username: 'snapinsight-e2e-customer@snapinsight.local',
  localAccountId: e2eCustomerUserId,
  name: 'SnapInsight E2E Customer',
  idToken: e2eCustomerAuthToken,
  idTokenClaims: {
    oid: e2eCustomerUserId,
    sub: e2eCustomerUserId,
    tfp: 'B2C_1_ceade_signup1',
    name: 'SnapInsight E2E Customer',
    emails: ['snapinsight-e2e-customer@snapinsight.local'],
  },
});
